import React from 'react';
import { PricingPlan } from './pricingData';
import styles from './Pricing.module.scss';

interface PricingCardProps {
  plan: PricingPlan;
}

export const PricingCard: React.FC<PricingCardProps> = ({ plan }) => {
  // Иконка галочки, чтобы не дублировать код
  const CheckIcon = () => (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="13" cy="13" r="8" fill="#22C55E" />
      <circle cx="13" cy="13" r="12" stroke="#22C55E" strokeWidth="1" />
      <path d="M9 13L11.5 15.5L17 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  return (
    <div className={`${styles.card} ${styles[plan.theme]}`}>
      <div className={styles.badge}>{plan.badge}</div>

      {/* Блок цены */}
      <div className={styles.priceBlock}>
        {plan.price && (
          <div className={`${styles.singlePrice} ${plan.theme==="light" ? styles.gradientText2 : ""}`}>{plan.price}</div>
        )}

        {plan.pricesList && (
          <div className={styles.priceList}>
            {plan.pricesList.map((item, index) => (
              <div key={index} className={styles.priceRow}>
                <span className={`${styles.priceValue} ${plan.theme==="dark" ? styles.gradientText : ""}`}>{item.value}</span>
                <span className={styles.priceLabel}>{item.label}</span>
              </div>
            ))}
            {plan.priceNote && <div className={styles.priceNote}>{plan.priceNote}</div>}
          </div>
        )}
      </div>

      <p className={styles.description}>{plan.description}</p>

      {/* Блок с фичами */}
      <div className={styles.featuresContainer}>
        <div className={styles.featuresTitle}>В стоимость входит:</div>
        <ul className={styles.featuresList}>
          {plan.features.map((feature, index) => (
            <li key={index} className={styles.featureItem}>
              <CheckIcon />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </div>

      <button className={styles.button}>{plan.buttonText}</button>
    </div>
  );
};